
export class ClientOptionError extends Error {
    constructor(message: string, public optionName: string, error?: Error) {
        super(ClientOptionError.buildMessage(message, optionName, error));
        this.name = 'ClientOptionError';
    }

    private static buildMessage(message: string, optionName: string, error?: Error) {
        return `${message} (Option '${optionName}')`;
    }
}